import { MenuData } from "assets/data/MenuData";
import Logo from "assets/images/Logo_lg_colo.svg";
import { NavLink } from "react-router-dom";
import ScrollReveal from "components/common/ScrollReveal";

const Footer = () => {
    return (
        <footer className="relative bg-gray-50/50">
            <div className="absolute inset-0 gradient-mesh pointer-events-none" />
            <div className="container relative">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 pb-10">
                    <ScrollReveal variant="up" className="lg:col-span-5">
                        <img
                            src={Logo}
                            className="w-44 mb-5"
                            alt="Adroit Systems LLC FZ"
                        />
                        <p className="text-lg font-semibold mb-4">
                            Let&apos;s get{" "}
                            <span className="text-primary">IT</span> done.
                        </p>
                        <p className="text-secondary/70 text-sm leading-relaxed mb-6">
                            Adroit Systems LLC FZ empowers global enterprises to
                            operate their mission-critical systems and
                            streamline operations while advancing IT
                            modernization, optimizing data architectures, and
                            ensuring security and scalability across public,
                            private, and hybrid cloud environments.
                        </p>
                    </ScrollReveal>

                    <ScrollReveal
                        variant="up"
                        delay={150}
                        className="lg:col-span-7"
                    >
                        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
                            {MenuData.map((menu, index) => (
                                <div key={index} className="footer-menu">
                                    <h4>{menu.title}</h4>
                                    {menu.isFooter && menu.footerData}
                                    {menu.subItems.map((item, subIndex) => (
                                        <div key={subIndex}>
                                            <NavLink to={item.url}>
                                                {item.title}
                                            </NavLink>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </ScrollReveal>
                </div>

                <div className="copywrite">
                    &copy; {new Date().getFullYear()} Adroit Systems LLC FZ. All
                    rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
